import React from "react";
import moment from 'moment'
import { getObject } from "../../utils/useful";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class TableStatusIndicator extends React.Component {

    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }
    componentDidUpdate(prevProps) {

    }

    calculation() {
        let value = '-1'
        let status = getObject(this.props.fullValues, this.props.header.information.relatedKey)
        let hasPayment = false
        // console.log(status)
        if (Array.isArray(status)) {
            // status.forEach(oneStatus => {
            for (let i = 0; i < status.length; i++) {
                const oneStatus = status[i];

                if (oneStatus.values.type === this.props.header.information.valueType) {

                    if (oneStatus.values.status == '0') {
                        value = "0"
                    }
                    if (oneStatus.values.status == '1') {
                        hasPayment = true
                        value = "1"

                    }
                }
            }
            // })

            let now = new Date()
            // status.forEach(oneStatus => {
            for (let i = 0; i < status.length; i++) {
                const oneStatus = status[i];

                if (oneStatus.values.type === this.props.header.information.valueType) {
                    if (oneStatus.values.status == '0' && oneStatus.values.dueDate <= moment(now).valueOf()) {
                        value = "2"
                    }
                }
            }


            let dayOfWeek = moment(now).day()
            let daysToReduce = 3
            if (dayOfWeek == 1 || dayOfWeek == 2 || dayOfWeek == 3) {
                daysToReduce = 5
            }


            if (!hasPayment && this.props.header.key == 'values.paymentStatus') {
                // status.forEach(oneStatus => {
                for (let i = 0; i < status.length; i++) {
                    const oneStatus = status[i];

                    if (oneStatus.values.type === this.props.header.information.valueType) {
                        if (oneStatus.values.status == '0' && oneStatus.values.dueDate <= moment(now).subtract(daysToReduce, 'days').valueOf()) {
                            value = "3"
                        }
                    }
                }
            }


        }

        return value
    }

    currentOption() {
        let value = this.calculation()
        // console.log(value)
        let result = { title: 'NaN' }
        this.props.header.information.items.forEach(option => {
            if (value == option.value) {
                result = Object.assign({}, option)
            }
        });
        // console.log(this.props.value)
        if (value == "0") {
            result.color = '#9ab'
        }
        return result
    }

    render() {
        return (
            <div className='ml-2 mr-2'>
                <p className=' text-center' style={{ fontSize: 14, backgroundColor: "transparent", color: this.currentOption().color }}>{this.currentOption().title}</p>
            </div>
        );
    }
}

export default TableStatusIndicator;
